export const PET_QUOTES = {
  zh: [
    "寵物不會活得跟我們一樣長，但牠們用一生的愛來陪伴我們。",
    "家不是一個地方，而是有寵物在的地方。",
    "寵物用無條件的愛教會我們如何成為更好的人。",
    "當你收養一隻寵物時，你不僅獲得了一位朋友，還獲得了一位家人。",
    "寵物的腳印雖小，卻在我們的心裡留下深深的足跡。",
    "寵物帶給我們的快樂，遠超過我們給予牠的照顧。",
    "養寵物的人永遠不會孤單，因為家裡總有一顆愛你的心。",
    "寵物不在乎你的外表、財富或社會地位，牠們只關心你的愛。",
    "世界上最純粹的愛，來自寵物的眼神。",
    "寵物不僅是我們的朋友，更是我們的心靈治療師。",
    "每天回家，最幸福的時刻就是看到寵物在門口等待。",
    "寵物的愛是世上最純真無私的，沒有任何條件。",
    "與寵物共度的每一天，都是生命中最珍貴的禮物。",
    "寵物教會我們如何活在當下，享受生活中的每一刻。",
    "無論多麼糟糕的一天，寵物的歡迎都能讓一切變得美好。"
  ],
  en: [
    "Pets don't live as long as we do, but they spend their entire lives loving us.",
    "Home is not a place, it's where your pet is.",
    "Pets teach us how to be better humans with their unconditional love.",
    "When you adopt a pet, you not only gain a friend but also a family member.",
    "The paw prints of pets may be small, but they leave deep impressions in our hearts.",
    "The joy our pets bring us far exceeds the care we provide them.",
    "Those who keep pets are never alone, as there's always a heart that loves you at home.",
    "Pets don't care about your appearance, wealth, or social status, they only care about your love.",
    "The purest love in the world comes from a pet's gaze.",
    "Pets are not just our friends, they are our soul therapists.",
    "The happiest moment of each day is seeing your pet waiting at the door when you come home.",
    "A pet's love is the most genuine and selfless in the world, without any conditions.",
    "Every day spent with your pet is the most precious gift in life.",
    "Pets teach us how to live in the moment and enjoy every second of life.",
    "No matter how bad your day has been, your pet's welcome can make everything wonderful."
  ]
};

export const PET_ACHIEVEMENTS = {
  zh: [
    { id: 'first-day', days: 1, name: '初來乍到', description: '與寵物相處的第一天', icon: '🐾' },
    { id: 'first-week', days: 7, name: '第一週', description: '寵物適應新家的一週', icon: '🏠' },
    { id: 'two-weeks', days: 14, name: '兩週相處', description: '建立初步信任關係', icon: '👋' },
    { id: 'first-month', days: 30, name: '一個月', description: '與寵物共度的第一個月', icon: '📆' },
    { id: 'fifty-days', days: 50, name: '50天里程碑', description: '寵物生活穩定', icon: '🎯' },
    { id: 'two-months', days: 60, name: '兩月之緣', description: '更加了解彼此', icon: '💫' },
    { id: 'ninety-days', days: 90, name: '三個月', description: '寵物已成為家庭一員', icon: '👨‍👩‍👦' },
    { id: 'hundred-days', days: 100, name: '百日紀念', description: '共度的第100天', icon: '💯' },
    { id: 'half-year', days: 183, name: '半年之喜', description: '半年的快樂時光', icon: '🎊' },
    { id: 'first-year', days: 365, name: '週年紀念', description: '一週年!值得慶祝', icon: '🎂' },
    { id: 'five-twenty', days: 520, name: '我愛你', description: '520天的愛', icon: '❤️', special: true },
    { id: 'two-years', days: 730, name: '兩年之約', description: '兩年的陪伴', icon: '🎉' },
    { id: 'thousand-days', days: 1000, name: '千日紀念', description: '千日相伴', icon: '🌟' },
    { id: 'one-three-one-four', days: 1314, name: '一生一世', description: '1314天的陪伴', icon: '🐶', special: true },
    { id: 'three-years', days: 1095, name: '三年有成', description: '三年的成長與愛', icon: '🏆' },
    { id: 'five-years', days: 1825, name: '五年之愛', description: '五年的深厚感情', icon: '💎' },
    { id: 'two-two-two-two', days: 2222, name: '愛你愛你', description: '2222天的愛', icon: '💕', special: true },
    { id: 'three-three-three-three', days: 3333, name: '三生三世', description: '3333天的陪伴', icon: '🌈', special: true },
    { id: 'ten-years', days: 3650, name: '十年之約', description: '十年的忠誠相伴', icon: '👑' },
    { id: 'five-two-zero-zero', days: 5200, name: '我愛你一萬次', description: '5200天的深情', icon: '💌', special: true },
    { id: 'fifteen-years', days: 5475, name: '十五年之愛', description: '十五年的不離不棄', icon: '🏅' },
    { id: 'six-six-six-six', days: 6666, name: '六六大順', description: '6666天的幸福陪伴', icon: '🍀', special: true },
    { id: 'twenty-years', days: 7300, name: '廿載同行', description: '二十年的相守相伴', icon: '👑' }
  ],
  en: [
    { id: 'first-day', days: 1, name: 'New Arrival', description: 'First day with your pet', icon: '🐾' },
    { id: 'first-week', days: 7, name: 'First Week', description: 'Pet adapting to new home', icon: '🏠' },
    { id: 'two-weeks', days: 14, name: 'Two Weeks Together', description: 'Building initial trust', icon: '👋' },
    { id: 'first-month', days: 30, name: 'First Month', description: 'First month together', icon: '📆' },
    { id: 'fifty-days', days: 50, name: '50 Days Milestone', description: 'Pet settling in well', icon: '🎯' },
    { id: 'two-months', days: 60, name: 'Two Months Journey', description: 'Getting to know each other better', icon: '💫' },
    { id: 'ninety-days', days: 90, name: 'Three Months', description: 'Pet is now family', icon: '👨‍👩‍👦' },
    { id: 'hundred-days', days: 100, name: '100 Days Milestone', description: '100 days together', icon: '💯' },
    { id: 'half-year', days: 183, name: 'Half Year', description: 'Half year of joy', icon: '🎊' },
    { id: 'first-year', days: 365, name: 'Anniversary', description: 'One year! Worth celebrating', icon: '🎂' },
    { id: 'five-twenty', days: 520, name: 'I Love You', description: '520 days of love', icon: '❤️', special: true },
    { id: 'two-years', days: 730, name: 'Two Years Journey', description: 'Two years of companionship', icon: '🎉' },
    { id: 'thousand-days', days: 1000, name: '1000 Days Milestone', description: 'A thousand days together', icon: '🌟' },
    { id: 'one-three-one-four', days: 1314, name: 'Forever and Ever', description: '1314 days of companionship', icon: '🐶', special: true },
    { id: 'three-years', days: 1095, name: 'Three Year Bond', description: 'Three years of growth and love', icon: '🏆' },
    { id: 'five-years', days: 1825, name: 'Five Years of Love', description: 'Five years of deep connection', icon: '💎' },
    { id: 'two-two-two-two', days: 2222, name: 'Love You Love You', description: '2222 days of love', icon: '💕', special: true },
    { id: 'three-three-three-three', days: 3333, name: 'Lifetime Bond', description: '3333 days of companionship', icon: '🌈', special: true },
    { id: 'ten-years', days: 3650, name: 'Ten Year Loyalty', description: 'Ten years of loyal companionship', icon: '👑' },
    { id: 'five-two-zero-zero', days: 5200, name: 'I Love You x10', description: '5200 days of deep affection', icon: '💌', special: true },
    { id: 'fifteen-years', days: 5475, name: 'Fifteen Years', description: 'Fifteen years of unwavering loyalty', icon: '🏅' },
    { id: 'six-six-six-six', days: 6666, name: 'Smooth Journey', description: '6666 days of happiness together', icon: '🍀', special: true },
    { id: 'twenty-years', days: 7300, name: 'Twenty Years United', description: 'Twenty years of companionship', icon: '👑' }
  ]
};

// Added many more significant milestones for pets
export const PET_MILESTONES = [
  1, 7, 14, 30, 50, 60, 90, 99, 100, 120, 183, 200, 222, 365, 
  500, 520, 666, 730, 888, 999, 1000, 1095, 1314, 1825, 
  2000, 2222, 3000, 3333, 3650, 4000, 5200, 5475, 6666, 
  7300, 8888, 9999, 10000
];

// Special milestones with cultural significance
export const SPECIAL_MILESTONES = [
  100, // 100 days milestone
  365, // 1 year birthday/adoption
  520,  // "I love you" in Chinese (我爱你)
  1314,  // "Forever" in Chinese (一生一世)
  2222,  // "Love you love you"
  3333,  // "Three lifetimes" (三生三世)
  5200,  // "I love you x10"
  6666   // "Smooth sailing" (六六大顺)
];

// Milestone categories for visual differentiation
export const MILESTONE_CATEGORIES = {
  FIRST_MOMENTS: [1, 7, 14, 30],
  EARLY_JOURNEY: [50, 60, 90, 99, 100, 120, 183, 200, 222],
  YEARLY: [365, 730, 1095, 1825, 3650, 5475, 7300],
  NUMERIC_SPECIAL: [500, 1000, 2000, 3000, 4000, 10000],
  CULTURAL_SPECIAL: [520, 666, 888, 999, 1314, 2222, 3333, 5200, 6666, 8888, 9999]
};

// Milestone icons mapped by days or categories
export const MILESTONE_ICONS = {
  1: '🐾',
  7: '🏠',
  14: '👋',
  30: '📆',
  100: '💯',
  365: '🎂',
  520: '❤️',
  999: '✨',
  1000: '🎊',
  1314: '🐶',
  1825: '💎',
  2222: '💕',
  3333: '🌈',
  3650: '👑',
  5200: '💌',
  6666: '🍀',
  8888: '🎊',
  9999: '🐱',
  default: '🐾'
};

// Legacy exports to maintain compatibility
export const LOVE_QUOTES = PET_QUOTES;
export const LOVE_ACHIEVEMENTS = PET_ACHIEVEMENTS;
export const LOVE_MILESTONES = PET_MILESTONES;